import { SortOrder } from "@arelia-types/data-models";

export interface Fan {
    id: string;
    identityId: string;
    fullName: string;
    email: string;
    phone: string;
    country: string;
    city: string;
    createdAt: string;
    partitionKey: string;
}

export enum FansSorting {
    createdDateAsc = "createdDateAsc",
    createdDateDesc = "createdDateDesc",
    nameAsc = "nameAsc",
    nameDesc = "nameDesc",
}

export type SortOrderMap = {
    [key in FansSorting]: SortOrder;
}

export type SortValueGetterMap = {
    [key in FansSorting]: (fan: Fan) => string | Date;
}